import { EncodeBase64 } from "../../../xconfig/utils.js";
import { CtResponse } from "../Fetch";
import { xget, xhttp } from "../Fetchv2.js";
import { MGSchema, Report, ReportBlock, ReportBlockSetting, tests_complete } from "../schemas/mg.schema";
import { PGSchema } from "../schemas/pg.schema.js";

export class Reports {
	getComparativeInfo(pgid: string, params: { profile: MGSchema.profiles["_id"]; users: string[] }) {
		let b64 = EncodeBase64(JSON.stringify(params));
		return xget<{
			users: PGSchema.users[];
			profile: MGSchema.profiles;
			profiles: MGSchema.profiles[];
			tests: Pick<tests_complete, "_id" | "tid" | "title" | "type" | "uid" | "complete" | "score" | "score_array" | "score_t17" | "score_t1000">[];
		}>(`/pages/${pgid}/compare-candidates`, { data: b64 });
	}

	getComparativeInfoPositions(pgid: string, params: { job_id: PGSchema.jobs["job_id"]; users: string[] }) {
		let b64 = EncodeBase64(JSON.stringify(params));
		return xget<{
			users: PGSchema.users[];
			profile: { job_id: PGSchema.jobs["job_id"]; title: PGSchema.jobs["title"]; tests: PGSchema.jobs["tests"] };
			profiles: { job_id: PGSchema.jobs["job_id"]; title: PGSchema.jobs["title"]; tests: PGSchema.jobs["tests"] }[];
			tests: Pick<tests_complete, "_id" | "tid" | "title" | "type" | "uid" | "complete" | "score" | "score_array" | "score_t17" | "score_t1000">[];
		}>(`/pages/${pgid}/compare-candidates-positions`, { data: b64 });
	}

	// CREAR REPORTE
	async createReport(report: Report): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp("/pages/report", "POST", { report });
		return response;
	}

	// AÑADIR UN NUEVO BLOQUE A LOS REPORTES
	async addReportBlock(id: string, block: ReportBlock): Promise<CtResponse<any>> {
		let response = await xhttp(`/pages/report/${id}/block`, "PUT", { block });
		return response;
	}

	// OBTENER #1 REPORTE
	async getReport(rid: string): Promise<CtResponse<any>> {
		let response = xget(`/pages/report/${rid}`);
		return response;
	}

	// OBTENER TODOS LOS REPORTES
	async getReports(pgid: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/reports/${pgid}`);
		return response;
	}

	// ACTUALIZAR EL BLOQUE DE LOS REPORTES
	async updateReportBlock(rid: string, bid: string, setting: ReportBlockSetting): Promise<CtResponse<any>> {
		let response = await xhttp(`/pages/report/${rid}/block/${bid}`, "PUT", { setting });
		return response;
	}

	// ELIMINAR REPORTE
	async deleteReport(rid: string): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/report/${rid}`, "DELETE");
		return response;
	}

	// ELIMINAR BLOQUE DE REPORTE
	async deleteReportBlock(rid: string, blkid: string): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/report/${rid}/block/${blkid}`, "DELETE");
		return response;
	}
}
